module.exports = __webpack_public_path__ + "static/media/interiorDesign.b3dd9124.jpg";